import React from 'react'

import { KitConnected } from './components/KitConnected'
import { KitGetStarted } from './components/KitGetStarted'
import { KitSyncJobActive } from './components/KitSyncJobActive'
import { useKit } from './hooks/useKit'

const DEFAULT_SYNC_JOB_KEYS = ['MEMBERS' as const, 'NEWSLETTER' as const]

export const AppsKitSettings = () => {
  const {
    syncStatus,
    configuration,
    // actions
    createSyncJob,
    isCreatingSyncJob,
  } = useKit()

  // For Kit, we assume it's always connected since it's a simpler integration
  // Show get started if no sync has ever been performed
  if (!syncStatus.hasSynced && !syncStatus.active) {
    return (
      <KitGetStarted
        onGetStarted={() => createSyncJob({ keys: DEFAULT_SYNC_JOB_KEYS })}
        isLoading={isCreatingSyncJob}
        dataCount={configuration.dataCount ?? 0}
      />
    )
  }

  if (syncStatus.active) {
    return <KitSyncJobActive status={syncStatus.progress} />
  }

  return <KitConnected />
}
